import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=91f744a4&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=91f744a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f744a4",
  null
  
)

export default component.exports